import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../../shared/services/auth.service";
import {savaquanFetchJson} from "../../../shared/services/http.service";
import {EquipmentDto, SaveEquipmentDto} from "../dtos/equipment.dto";
import {EquipmentCatalog} from "../profile/equipment-catalog";

const api = (path: string) => `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/${path}`;

export async function getAllEquipment(navigate: NavigateFunction): Promise<EquipmentDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  const equipment = await fetch(
    api('equipment'),
    {headers: {Authorization: `Bearer ${token}`}})
    .then(async response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch equipment: ${response.statusText}`);
      }
      return await response.json() as EquipmentDto[]
    });
  return equipment;
}

/** One machine; a SavaquanHttpError carries the status (403: no access to the equipment list). */
export const getEquipment = (navigate: NavigateFunction, equipmentId: number) =>
  savaquanFetchJson<EquipmentDto>(api(`equipment/${equipmentId}`), {navigate});

/** The catalog the add-equipment steps pick from (backend/Accusite/Api/Catalog/equipment-catalog.json). */
export const getEquipmentCatalog = (navigate: NavigateFunction) =>
  savaquanFetchJson<EquipmentCatalog>(api('equipment/catalog'), {navigate});

export const createEquipment = (navigate: NavigateFunction, body: SaveEquipmentDto) =>
  savaquanFetchJson<EquipmentDto>(api('equipment'), {
    navigate,
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(body),
  });

export const updateEquipment = (navigate: NavigateFunction, equipmentId: number, body: SaveEquipmentDto) =>
  savaquanFetchJson<EquipmentDto>(api(`equipment/${equipmentId}`), {
    navigate,
    method: 'PATCH',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(body),
  });

export async function deleteEquipment(navigate: NavigateFunction, equipmentId: number): Promise<void> {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    api(`equipment/${equipmentId}`),
    {
      method: 'DELETE',
      headers:
        {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
    });
  if(!response.ok) {
    throw new Error(`Failed to delete equipment: ${response.statusText}`);
  }
}
